import { CloseIcon } from "$components/icons";
import { DashboardLinks } from "$components/navigation/dashboardLinks/DashboardLinks";
import type { Territory } from "$global-providers/config-provider/provider";
import { TERRITORY } from "$routes/_lib/constants";
import { Drawer, IconButton } from "@material-ui/core";
import List from "@material-ui/core/List";
import type { Role } from "elephant-web/gql";
import { AppVersionWithDevToolsToggle } from "./app-version-with-dev-tools-toggle";
import { useSideMenuContext } from "./context";
import {
  AdminControlPanelLink,
  ClinicControlPanelLink,
  HomeLink,
  InventoryLink,
  InventoryRequests,
  LogoutLink,
  UserSettingsLink,
  ViewAncRegisterLink,
  ViewChildImmunisationRegisterLink,
  ViewNigeriaDailyOutpatientRegisterLink,
  ViewNigeriaGeneralAttendanceRegisterLink,
  ViewPatientRegisterLink,
  ViewRegisterDownloadRequestsLink,
} from "./links";

export interface Flags {
  ancRegister?: boolean;
  nigeriaDailyOutpatientRegister?: boolean;
  nigeriaGeneralAttendanceRegister?: boolean;
  immunisationRegisterEnabled?: boolean;
}

interface Props {
  userRole?: Role;
  territory: Territory;
  organisationId: string;
  facilityId: string;
  featureFlags: Flags;
}

export const LeftSideMenu: FC<Props> = ({
  userRole,
  featureFlags: { immunisationRegisterEnabled },
  territory,
  organisationId,
  facilityId,
}) => {
  const { closeMenu, currentMenu, closable, isOpen } = useSideMenuContext();

  return (
    <Drawer
      open={isOpen}
      onClose={closable ? closeMenu : undefined}
      anchor="left"
    >
      {closable && (
        <IconButton
          onClick={closeMenu}
          style={{ width: "min-content", padding: 24 }}
        >
          <CloseIcon />
        </IconButton>
      )}
      <List>
        <HomeLink />
        <AdminControlPanelLink userRole={userRole} />
        <ClinicControlPanelLink userRole={userRole} />
        <InventoryLink userRole={userRole} />
        <InventoryRequests userRole={userRole} />
        <ViewPatientRegisterLink userRole={userRole} />
        <ViewAncRegisterLink userRole={userRole} />
        {immunisationRegisterEnabled && (
          <ViewChildImmunisationRegisterLink userRole={userRole} />
        )}
        {territory === TERRITORY.NIGERIA && (
          <>
            <ViewNigeriaDailyOutpatientRegisterLink userRole={userRole} />
            <ViewNigeriaGeneralAttendanceRegisterLink userRole={userRole} />
          </>
        )}
        <ViewRegisterDownloadRequestsLink userRole={userRole} />
        <DashboardLinks
          territory={territory}
          roleName={userRole}
          organisationId={organisationId}
          facilityId={facilityId}
        />
      </List>
      <List style={{ marginTop: "auto" }}>
        <UserSettingsLink />
        <LogoutLink />
        <AppVersionWithDevToolsToggle version={`v${APP_VERSION_SEMANTIC}`} />
      </List>
    </Drawer>
  );
};
